// client/api/services/adminSupportService.ts
import { apiClient } from '../client';
import { ENDPOINTS } from '../endpoints';

export const ADMIN_SUPPORT_STATS = async (): Promise<unknown> => {
  const res = await apiClient.get<unknown>(ENDPOINTS.ADMIN_SUPPORT.STATS);
  return res.data;
};

export const ADMIN_SUPPORT_TICKETS = async (params?: {
  status?: string; search?: string; priority?: string; category?: string; page?: number; limit?: number;
}): Promise<unknown> => {
  const res = await apiClient.get<unknown>(ENDPOINTS.ADMIN_SUPPORT.TICKETS, { params });
  return res.data;
};

export const ADMIN_SUPPORT_TICKET_DETAILS = async (id: string): Promise<unknown> => {
  const res = await apiClient.get<unknown>(ENDPOINTS.ADMIN_SUPPORT.TICKET_DETAILS(id));
  return res.data;
};

export const ADMIN_SUPPORT_REPLY = async (id: string, content: string, isInternal = false): Promise<unknown> => {
  const res = await apiClient.post<unknown>(ENDPOINTS.ADMIN_SUPPORT.REPLY(id), { content, isInternal });
  return res.data;
};

export const ADMIN_SUPPORT_SET_STATUS = async (id: string, status: string, note?: string): Promise<unknown> => {
  const res = await apiClient.patch<unknown>(ENDPOINTS.ADMIN_SUPPORT.STATUS(id), { status, note });
  return res.data;
};
